import React from "react";

function ContactCards(props) {
	return (
		<div className="contactcards">
			<img src={props.contact.imgUrl} width="150" alt="" />
			<h3>name: {props.contact.name}</h3>
			<h2 style={{ display: props.contact.title ? "block" : "none" }}>
				title: {props.contact.title}
			</h2>
			<p>des: {props.contact.description}</p>
		</div>
	);
}

export default ContactCards;
